import React from 'react';
import type { Theme } from '../../../core/types';
import Element from '../../../core/Element';

interface ContentAfterCTAComponentProps {
  content: React.ReactNode;
  theme?: Theme;
}

function ContentAfterCTAComponent({
  content,
  theme,
}: ContentAfterCTAComponentProps) {
  return (
    <Element
      theme={{
        marginTop: 20,
        ...theme,
      }}
    >
      {content}
    </Element>
  );
}

export default ContentAfterCTAComponent;
